// extracted by mini-css-extract-plugin
module.exports = {"metric":"Metric-module__metric___21sCq"};